import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSocketIO from 'vue-socket.io'
//import Home from '../views/Home.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    component: () => import('../views/Main.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/control',
    name: 'Control',
    component: () => import('../views/Control.vue'),
    beforeEnter (to, from, next) {
       if (!Vue.prototype.$socket) { 
         Vue.use(new VueSocketIO({
            debug: true,
             connection: 'https://mcdd.ccms.live:8020'
            
            
          })
        );
       }
       next()
    }
  },
  {
    path: '/livedata/:ulbareacode',
    name: 'Devices',
    component: () => import('../views/Livedata.vue'),
    beforeEnter (to, from, next) {
       if (!Vue.prototype.$socket) { 
        // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
         Vue.use(new VueSocketIO({
            debug: false,
            connection:'https://mcdd.ccms.live:8020'
          })
        );
       }
       next()
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/complaints',
    name: 'Complaints',
    component: () => import('../views/Complaints.vue')
  },
  {
    path: '/state-dashboard/:stateid',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/user-roles',
    name: 'User Roles',
    component: () => import('../views/UserRoles.vue')
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue')
  },
  {
    path: '/devices/:ulbareacode',
    name: 'Devices',
    component: () => import('../views/Devices.vue'),
    beforeEnter (to, from, next) {
      if (!Vue.prototype.$socket) { 
       // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
        Vue.use(new VueSocketIO({
            debug: true,
            connection: 'https://mcdd.ccms.live:8020'
          })
        );
      }
      next()
    }
  },
  {
    path: '/device-data/:imeino',
    name: 'Device Record',
    component: () => import('../views/DeviceRecord.vue'),
    beforeEnter (to, from, next) {
      if (!Vue.prototype.$socket) { 
       // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
        Vue.use(new VueSocketIO({
            debug: true,
            connection: 'https://mcdd.ccms.live:8020'
          })
        );
      }
      next()
    }
  },
  {
    path: '/device-fault/:imeino',
    name: 'Device Fault Record',
    component: () => import('../views/DeviceFaultLogs.vue')
  },
  {
    path: '/devices-filter/:filter',
    name: 'Devices Filter',
    component: () => import('../views/DevicesFiIter.vue')
  },
  {
    path: '/report-ulb/:ulbareacode',
    name: 'ULB Record',
    component: () => import('../views/UlbReport.vue')
  },
  {
    path: '/zones',
    name: 'Zone Record',
    component: () => import('../views/Zones.vue')
  },
  {
    path: '/device-group',
    name: 'Device group',
    component: () => import('../views/DeviceGroup.vue')
  },
  {
    path: '/ulbs',
    name: 'ULB Record',
    component: () => import('../views/ULBs.vue'),
    beforeEnter (to, from, next) {
      if (!Vue.prototype.$socket) { 
       // console.log(Vue.prototype.$session.get('weburl')+':'+Vue.prototype.$session.get('webport'));
        Vue.use(new VueSocketIO({
            debug: true,
            connection: 'https://mcdd.ccms.live:8020'
          })
        );
      }
      next()
    }
  },
  {
    path: '/wards',
    name: 'Ward Record',
    component: () => import('../views/Wards.vue')
  },
  {
    path: '/cities',
    name: 'City Record',
    component: () => import('../views/City.vue')
  },
  {
    path: '/controllers/:feederno',
    name: 'Controllers',
    component: () => import('../views/Controller.vue')
  },
  {
    path: '/controller-data/:uniqueid',
    name: 'Controller Data',
    component: () => import('../views/ControllerRecord.vue')
  },
  {
    path: '/device-report',
    name: 'Download Device Report',
    component: () => import('../views/DeviceReport.vue')
  },
  {
    path: '/ulb-report',
    name: 'Download ULB Report',
    component: () => import('../views/ReportULB.vue')
  },
  {
    path: '/device-reports',
    name: 'Download Device Report',
    component: () => import('../views/DailyReports.vue')
  },
  {
    path: '/consumption',
    name: 'Consumption Record',
    component: () => import('../views/Consumption.vue')
  },
  {
    path: '/consumption2',
    name: 'Consumption Record',
    component: () => import('../views/Consumption2.vue')
  },
  {
    path: '/dashboard-reports',
    name: 'Dashboard Reports',
    component: () => import('../views/DashboardReports.vue')
  },
  {
    path: '/dashboard-report-details/:deviceId',
    name: 'Dashboard Reports device',
    component: () => import('../views/DeviceRecorddashboard.vue')
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance.vue')
  },
  {
    path: '/ccms-testing',
    name: 'CCMS Testing',
    component: () => import('../views/PortTester.vue')
  },
  {
    path: '/replace-devices',
    name: 'Replace Device',
    component: () => import('../views/ReplaceDevice.vue')
  },
  {
    path: '/monthlyconsumption',
    name: 'Consumption Record',
    component: () => import('../views/MonthlyConsumption.vue')
  },
  {
    path: '/monthlyconsumption_fpn',
    name: 'Consumption Record pfn',
    component: () => import('../views/MonthlyConsumption_fpn.vue')
  },
  {
    path: '/reports/:reporttype',
    name: 'Download Reports',
    component: () => import('../views/Reports.vue')
  },
  {
    path: '/find-device',
    name: 'Search CCMS',
    component: () => import('../views/FindDevice.vue')
  },
  {
    path: '/live-tracking',
    name: 'Live Tracking',
    component: () => import('../views/LiveTracking.vue')
  },
  {
    path: '/corrections',
    name: 'Download Reports',
    component: () => import('../views/DeviceCorrection.vue')
  },
  {
    path: '/master-devices',
    name: 'Master Devices',
    component: () => import('../views/MasterDevices.vue')
  },
  {
    path: '/unregistered',
    name: 'Unregistered Devices',
    component: () => import('../views/UnregisteredDevices.vue')
  },
  {
    path: '/pushdata',
    name: 'Push Data',
    component: () => import('../views/PushData.vue')
  },
  {
    path: '/rtc-mismatch',
    name: 'RTC Mismatch',
    component: () => import('../views/RtcMismatch.vue')
  },
  /*{
    path: '/ulbmap',
    name: 'ULB Map',
    component: () => import('../views/UlbsMap.vue')
  },*/
  {
    path: '/inventory',
    name: 'Inventory Management',
    component: () => import('../views/inventory/Dashboard.vue')
  },
  { 
    path: '/inventory/led-detail/:fp_no',
    name: 'Inventory details',
    component: () => import('../views/inventory/LedDetails.vue')
  },
  { 
    path: '/inventory/led-report',
    name: 'Inventory Reports',
    component: () => import('../views/inventory/LedReport.vue')
  },
  { 
    path: '/inventory/vendor',
    name: 'Inventory vendor Reports',
    component: () => import('../views/inventory/Vendor.vue')
  },
  {
    path: '/logout',
    name: 'Logout',
    component: () => import('../views/Logout.vue')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
